import AddCeremonyModal from '../modals/AddCeremonyModal'
import useTranslation from 'hooks/useTranslation'
import { openMap } from 'utils/openMap'
import React, { useState } from 'react'
import Button from 'components/Button'
import { Form, Step, StepKeys } from '..'

interface CeremonyProps {
  form: Form
  setForm: React.Dispatch<React.SetStateAction<Form>>
}

const list: StepKeys[] = ['body_exposure', 'burial_in_cemetery', 'funeral_ceremony']

const Ceremony: React.FC<CeremonyProps> = ({ form, setForm }) => {
  const [modal, setModal] = useState<StepKeys | ''>('')
  const { t } = useTranslation('obituary')

  return (
    <>
      {modal && <AddCeremonyModal
        form={form}
        stepKey={modal}
        setForm={setForm}
        onClose={() => {
          setModal('')
        }}
      />}

      <div className='infoLabel'>
        Szczegóły ceremonii pogrzebowej
      </div>

      {list.map(key => <div
        key={key}
        className='myInput'>
        <label>{t(key)}</label>
        {form.steps[key]
          ? (({ place, address, date, time, place_description, gps_latitude, gps_longitude }: Step) => <div
            className='addObituary__ceremony'>
            {place_description && <div className='addObituary__ceremony__row'>
              <i className='icon icon--church' />
              <div>
                <span>{place_description}</span>
              </div>
            </div>}
            <div className='addObituary__ceremony__row'>
              <i className='icon icon--navigate' />
              <div>
                <div>
                  <span>{place}</span>
                </div>
                <div>
                  <span className='--link'>{address}</span>
                </div>
              </div>
              {gps_latitude && gps_longitude && <Button
                type='round'
                text='Nawiguj'
                action={() => {
                  openMap(gps_latitude, gps_longitude)
                }}
              />}
            </div>
            <div className='addObituary__ceremony__row'>
              <i className='icon icon--calendar' />
              <div>
                <span>{date} o godzinie {time}</span>
              </div>
            </div>
            <div className='addObituary__ceremony__buttons'>
              <Button
                type='empty'
                text='Edytuj'
                action={() => {
                  setModal(key)
                }}
              />
              <Button
                type='empty'
                text='Usuń'
                action={() => {
                  setForm(prev => {
                    const { [key]: _, ...steps } = prev.steps
                    return {
                      ...prev,
                      steps
                    }
                  })
                }}
              />
            </div>
          </div>)(form.steps[key] || {} as Step)
          : <div className='addObituary__input__container'>
            <div
              className='empty'
              onClick={() => {
                setModal(key)
              }}>Kliknij, aby dodać
            </div>
            <i className='icon icon--add' />
          </div>}
      </div>)}
    </>
  )
}

export default Ceremony